(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/phone-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/phone-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  validateIsOnlyDigits
} = svs.ticket_partner.utils;
const {
  PHONE
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  LABEL,
  REQUIRED_ERROR
} = svs.ticket_partner.sharedComponents.input.constants.TEXTS.PHONE_NUMBER;
const PhoneNrInput = _ref => {
  let {
    handleChange,
    state,
    isLessSpace = false
  } = _ref;
  return React.createElement(TextInput, {
    errorMessageRequired: REQUIRED_ERROR,
    id: PHONE,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    name: PHONE,
    onChange: handleChange,
    validateFn: validateIsOnlyDigits,
    value: state[PHONE]
  });
};
svs.ticket_partner.sharedComponents.input.PhoneNrInput = PhoneNrInput;

 })(window);